import { render } from "./MediaFileTypeMovie.vue?vue&type=template&id=2631956d"
import script from "./MediaFileTypeMovie.vue?vue&type=script&lang=js"
export * from "./MediaFileTypeMovie.vue?vue&type=script&lang=js"
script.render = render

export default script